import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  private _available = LocalStorageService.isLocalStorageAvailable();

  constructor() {
    if (!this._available) {
      console.warn('LocalStorage is not available');
    }
  }

  static isLocalStorageAvailable(): boolean {
    try {
      const testKey = '__test__';
      localStorage.setItem(testKey, testKey);
      localStorage.removeItem(testKey);
      return true
    } catch (err) {
      console.error(err);
      return false
    }
  }

  get(key: string): any {
    if (!this._available) return;
    return localStorage.getItem(key);
  }

  set(key: string, value: any) {
    if (!this._available) return;
    localStorage.setItem(key, value);
  }

  remove(key: string) {
    if (!this._available) return;
    localStorage.removeItem(key);
  }

  clear() {
    if (!this._available) return;
    localStorage.clear();
  }

  // Local storage memorizes data in a key-value form, this means values ​​are stored as strings. 
  // So, if we want to have a real object (or list) to deal with, we must convert the string to a valid JavaScript object. (JSON)
  public getDataJSON(key: string): any {
    if (!this._available) return null;
    return JSON.parse(localStorage.getItem(key));
  }

  public saveDataJSON(key: string, data: any) {
    if (!this._available) return;
    localStorage.setItem(key, JSON.stringify(data));
  }

}
